var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.referenceCode)?_c('span',[_vm._t("prepend"),_vm._v(" "),(_vm.referenceCode.url)?_c('a',{class:{
      'event-reference-code': true,
      'force-current-color': _vm.forceCurrentColor,
      'link-force-style': !_vm.forceCurrentColor
    },attrs:{"target":"_blank","href":_vm.referenceCode.url},on:{"click":function($event){$event.preventDefault();return _vm.openLink.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.referenceCode.code)+"\n  ")]):_c('span',{class:{
      'event-reference-code': true,
      'force-current-color': _vm.forceCurrentColor
    }},[_vm._v(_vm._s(_vm.referenceCode.code))])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }